import React, { useState } from "react";

// Static Gallery Component with 44 images + Banner Breadcrumb
export default function Gallery() {
  const [index, setIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  const images = [
    "/images/img1.jpg",
    "/images/img2.jpg",
    "/images/img3.jpg",
    "/images/img4.jpg",
    "/images/img5.jpg",
    "/images/img6.jpg",
    "/images/img7.jpg",
    "/images/img8.jpg",
    "/images/img9.jpg",
    "/images/img10.jpg",
    "/images/img11.jpg",
    "/images/img12.jpg",
    "/images/img13.jpg",
    "/images/img14.jpg",
    "/images/img15.jpg",
    "/images/img16.jpg",
    "/images/img17.jpg",
    "/images/img18.jpg",
    "/images/img19.jpg",
    "/images/img20.jpg",
    "/images/img21.jpg",
    "/images/img22.jpg",
    "/images/img23.jpg",
    "/images/img24.jpg",
    "/images/img25.jpg",
    "/images/img26.jpg",
    "/images/img27.jpg",
    "/images/img28.jpg",
    "/images/img29.jpg",
    "/images/img30.jpg",
    "/images/img31.jpg",
    "/images/img32.jpg",
    "/images/img33.jpg",
    "/images/img34.jpg",
    "/images/img35.jpg",
    "/images/img36.jpg",
    "/images/img37.jpg",
    "/images/img38.jpg",
    "/images/img39.jpg",
    "/images/img40.jpg",
    "/images/img41.jpg",
    "/images/img42.jpg",
    "/images/img43.jpg",
    "/images/img44.jpg",
  ];

  const next = () => setIndex((i) => (i + 1) % images.length);
  const prev = () => setIndex((i) => (i - 1 + images.length) % images.length);
  const open = (i) => {
    setIndex(i);
    setIsOpen(true);
  };

  return (
    <section className="max-w-6xl mx-auto p-0">
      {/* Banner Breadcrumb Section */}
      <div
        className="relative bg-cover bg-center h-64 sm:h-72 md:h-80 flex items-center justify-center mb-10 rounded-2xl"
        style={{ backgroundImage: "url('https://thumbs.dreamstime.com/b/d-wallpaper-mural-design-floral-geometric-objects-gold-ball-pearls-gold-jewelry-wallpaper-purple-flowers-will-154345462.jpg')" }}
      >
        {/* Overlay for readability */}
        <div className="absolute inset-0 bg-black/50 rounded-2xl"></div>
        <div className="relative z-10 text-center text-white">
          {/* <p className="text-sm uppercase tracking-wide">Breadcrumb</p> */}
           <p className="text-sm uppercase tracking-wide">Our Exclusive Collection</p>
          <h2 className="text-4xl md:text-5xl font-extrabold">Our Gallery</h2>
        </div>
      </div>

      {/* Main display */}
      <div className="relative rounded-2xl overflow-hidden shadow-lg bg-gray-50">
        <img
          src={images[index]}
          alt={`Gallery image ${index + 1}`}
          className="w-full h-[56vh] object-contain bg-white"
          onClick={() => setIsOpen(true)}
          style={{ cursor: "zoom-in" }}
        />

        <button
          aria-label="Previous"
          onClick={prev}
          className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white p-2 rounded-full shadow-md"
        >
          ‹
        </button>
        <button
          aria-label="Next"
          onClick={next}
          className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white p-2 rounded-full shadow-md"
        >
          ›
        </button>

        <div className="absolute left-4 bottom-4 bg-black/60 text-white text-sm px-3 py-1 rounded-full">
          {index + 1} / {images.length}
        </div>
      </div>

      {/* Grid preview */}
      <div className="mt-6 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
        {images.map((src, i) => (
          <button
            key={i}
            onClick={() => open(i)}
            className="overflow-hidden rounded-lg shadow-sm bg-white hover:shadow-md transition"
          >
            <img src={src} alt={`grid-${i}`} className="w-full h-40 object-cover" />
          </button>
        ))}
      </div>

      {/* Lightbox */}
      {isOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4"
          onClick={() => setIsOpen(false)}
        >
          <div
            className="max-w-[90vw] max-h-[90vh] relative"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={images[index]}
              alt={`Lightbox ${index + 1}`}
              className="w-full h-full object-contain"
            />

            <button
              onClick={() => setIsOpen(false)}
              className="absolute top-4 right-4 bg-white/90 rounded-full p-2"
              aria-label="Close"
            >
              ✕
            </button>

            <button
              onClick={prev}
              className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/90 rounded-full p-2"
            >
              ‹
            </button>
            <button
              onClick={next}
              className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/90 rounded-full p-2"
            >
              ›
            </button>

            <div className="absolute left-1/2 -translate-x-1/2 bottom-4 bg-black/60 text-white px-3 py-1 rounded-full text-sm">
              {index + 1} / {images.length}
            </div>
          </div>
        </div>
      )}
    </section>
  );
}